// extracted by mini-css-extract-plugin
export default {"issueType":"CustomerIssuesTable_issueType__6yCG-"};